import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { map, get } from "lodash";

import Grid from "@material-ui/core/Grid";

import { car, truck } from "../../../constants/common";

import {
  displayData,
  displayPercentage,
  /*calculatePercentage,*/
} from "../../../utils/data";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  container: {
    border: `1px solid ${colors.veryLighPink}`,
    borderRadius: "4px",
    margin: "12px",
    padding: "12px",
    width: "250px",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "10px",
    "& img": {
      maxWidth: "40px",
      maxHeight: "24px",
    },
  },
  value: {
    fontWeight: 500,
    fontSize: "1.857em !important",
    color: colors.black87,
    marginRight: "5px",
    lineHeight: "26px",
    verticalAlign: "text-bottom",
  },
  percentage: {
    fontSize: "1.142em",
    color: colors.black87,
  },
  licensePlates: {
    "& span": {
      margin: "0px 3px",
      fontSize: "1.142em",
    },
  },
};

const MdcEntranceExit = (props) => {
  const {
    classes,
    type,
    total,
    percentage,
    data,
    deltas,
    licensePlates,
  } = props;

  return (
    <Grid item className={classes.container}>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        style={{ height: "100%" }}
      >
        <Grid item style={{ marginBottom: "10px" }}>
          <Grid container alignItems="flex-end">
            <Grid item className={classes.iconContainer}>
              <img
                src={
                  type === car
                    ? images.car
                    : type === truck
                    ? images.truckIconBlack
                    : images.trailerIconBlack
                }
                alt="icon"
              />
            </Grid>
            <Grid item className={classes.value}>
              {displayData(total)}
            </Grid>
            <Grid item className={classes.percentage}>
              {displayPercentage(percentage)}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          style={{
            display: "flex",
            alignItems: "flex-end",
            minHeight: "20px",
            marginBottom: "20px",
          }}
        >
          <Grid container direction="column">
            {map(deltas, (delta, index) => (
              <Grid item key={index}>
                <Grid container alignItems="center">
                  <Grid item className="text-87 bold-500">
                    {delta.title}:
                  </Grid>
                  <Grid item className="text-54" style={{ margin: "0px 7px" }}>
                    {displayData(delta.value)}
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid container direction="column">
            {map(data, (item, index) => (
              <Grid item key={index} style={{ margin: "6px 0px" }}>
                <Grid container alignItems="flex-end">
                  <Grid item className={classes.value}>
                    {displayData(item.value)}
                  </Grid>
                  <Grid item className={classes.percentage}>
                    {displayPercentage(item.percentage)}
                  </Grid>
                  <Grid
                    item
                    className={"text-54"}
                    style={{ marginLeft: "7px" }}
                  >
                    {item.title}
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item style={{ marginTop: "30px" }}>
          <Grid container alignItems="center">
            <Grid
              item
              className="text-87 bold-500"
              style={{
                marginRight: "10px",
              }}
            >
              {I18n.get("dashboard_distinctLicensePlates")}:
            </Grid>
            <Grid item>
              <span className={classes.value}>
                {displayData(get(licensePlates, ["value"]))}
              </span>
            </Grid>
          </Grid>
          {/* <Grid container direction="column">
            <Grid
              item
              className="text-87 bold-500"
              style={{
                borderBottom: `1px solid ${colors.veryLighPink}`,
                marginBottom: "8px",
              }}
            >
              {I18n.get("dashboard_distinctLicensePlates")}
            </Grid>
            <Grid item className={classes.licensePlates}>
              <span className={classes.value}>
                {displayData(get(licensePlates, ["value"]))}
              </span>
              <span>
                {displayPercentage(
                  calculatePercentage(
                    get(licensePlates, ["value"]),
                    get(licensePlates, ["total"])
                  )
                )}
              </span>
              <span>{I18n.get("common_of")}</span>
              <span className={classes.value}>
                {displayData(get(licensePlates, ["total"]))}
              </span>
              <span style={{ fontSize: "1em" }}>
                ({I18n.get("dashboard_allProfiles")})
              </span>
            </Grid>
          </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(MdcEntranceExit);
